import * as fields from '@Forms/validation/fields';

import type { CountryCode } from '@Types/Base';
interface Params {
  country: CountryCode;
  lang: string;
}

const errorMessages = {
  ru: {
    requiredMessage: 'Сообщение не может быть пустым',
  },
  uz: {
    requiredMessage: "Xabar bo'sh bo'lishi mumkin emas",
  },
  kk: {
    requiredMessage: 'Хабарлама бос болуы мүмкін емес',
  },
};

export default ({ country, lang }: Params) => {
  return {
    title: 'JSON schema',
    $schema: 'http://json-schema.org/draft-07/schema',
    type: 'object',
    properties: {
      name: fields.firstName(lang),
      mailFrom: fields.email(lang, { minLength: 1 }),
      phone: fields.phone({ country, lang }),
      message: {
        description: 'Сообщение',
        type: 'string',
        minLength: 1,
        errorMessage: {
          minLength: errorMessages[lang].requiredMessage,
          required: errorMessages[lang].requiredMessage,
        },
      },
    },
    required: ['mailFrom', 'message'],
  };
};
